import { Printer } from "react-feather";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { Href, Print } from "../../../../Constants/Constants";
import { EmptyTaskClassProp } from "../../../../Types/TaskType";
import SearchNotFoundClass from "../../../CommonComponents/SearchNotFound/SearchNotFoundClass";

const EmptyTaskClass:React.FC<EmptyTaskClassProp> = ({ title }) => {
  return (
    <Card className="mb-0">
      <CardHeader className="d-flex">
        <H5 className="mb-0">{title}</H5>
        <Link to={Href}>
          <Printer className="me-2" />
          {Print}
        </Link>
      </CardHeader>
      <CardBody>
        <SearchNotFoundClass word="task" />
      </CardBody>
    </Card>
  );
};
export default EmptyTaskClass;
